import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../axois_V2/axoisWithAuthV2";
import { throwError } from "../utils/error";
import { BasePayload } from "../types";

export const categoryBaseUrl_V2 = "/category/v2";
interface CreateEditCategoryPayload {
    name: string;
}

export const getAllCategories_V2 = async (payload?: BasePayload) => {
    try {
        const res = await axiosGet(`${categoryBaseUrl_V2}`, { params: payload });
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const createCategory_V2 = async (payload: CreateEditCategoryPayload) => {
    try {
        const res = await axiosPost(`${categoryBaseUrl_V2}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const updateCategory_V2 = async (categoryId: string, payload: CreateEditCategoryPayload) => {
    try {
        const res = await axiosPut(`${categoryBaseUrl_V2}/${categoryId}`, payload);
        return res;
    } catch (error) {
        throwError(error);
    }
};

export const deleteCategory_V2 = async (categoryId: string) => {
    try {
        const res = await axiosDelete(`${categoryBaseUrl_V2}/${categoryId}`);
        return res;
    } catch (error) {
        throwError(error);
    }
};